import dayjs from "dayjs";

export const getRemainingTime = (timestamp) => {
  const timestampDayjs = dayjs(timestamp);
  const now = dayjs();
  if (timestampDayjs.isBefore(now))
    return {
      seconds: "00",
      minutes: "00",
      hours: "00",
    };
  return {
    seconds: addZeros(timestampDayjs.diff(now, "seconds") % 60),
    minutes: addZeros(timestampDayjs.diff(now, "minutes") % 60),
    hours: addZeros(timestampDayjs.diff(now, "hours") % 24),
  };
};

const addZeros = (n) => (n < 10 ? `0${n}` : n);

export const checkIfOffertIsAlmostExpired = (timestamp, maxNumber, unit) => {
  const timestampDayjs = dayjs(timestamp);
  const now = dayjs();
  return timestampDayjs.diff(now, unit) <= maxNumber;
};
